// vuex
import { mapState } from 'vuex'

// constants
import { SIDE_NAV } from '@/constants'

// components
import maSideNav from './components/sidenav'

export default {
  name: 'sidenavLayout',
  data: function () {
    return {
      dataUserRoutes: [],
      isInIframe: false
    }
  },
  components: {
    maSideNav
  },
  computed: {
    ...mapState({
      stateUserRoutes: state => state.user.routes || []
    })
  },
  methods: {
    checkRoutes: function (routes) {
      routes.forEach(route => {
        // add
        const routeMetaType = route.meta.type

        if (routeMetaType.indexOf(SIDE_NAV) >= 0) {
          this.dataUserRoutes.push(route)
        }

        // has childrens? call again
        if (route.children) {
          this.checkRoutes(route.children)
        }
      })
    },
    handleInIframeClass() {
      const isInFnolFlow = this.FNOLFlow.isExecuting
      const isInIgnitionIframe = this.FNOLFlow.isIgnitionPlatform

      if (isInFnolFlow || isInIgnitionIframe) { this.isInIframe = true }
    }
  },
  watch: {
    stateUserRoutes () {
      this.dataUserRoutes = []
      this.checkRoutes(this.stateUserRoutes)
    }
  },
  beforeMount: function () {
    this.dataUserRoutes = []
    this.checkRoutes(this.stateUserRoutes)
    this.handleInIframeClass()
  }
}
